import {
	EnhancedDropDownRHFWithLabel,
	EnhancedRadioGroupRHFWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface IPADAgreenmentBankAccountSettingsFieldsPanel { }
export const PADAgreenmentBankAccountSettingsFieldsPanel: FC<
	IPADAgreenmentBankAccountSettingsFieldsPanel
> = ({ }) => {
	return (
		<Box sx={{ "& .MuiTypography-root": { fontSize: ".875rem" } }}>
			<EnhancedRadioGroupRHFWithLabel
				label="Account Type"
				name="accountType"
				selectedValue={100}
				key="accountType"
				testId="accountType"
				options={[
					{
						label: "Chequing Account",
						value: 100,
					},
					{
						label: "Saving Account",
						value: 200,
					}
				]}
				displayAsRow={false}
			/>
			<EnhancedRadioGroupRHFWithLabel
				label="These services are for"
				name="theseServicesAreFor"
				selectedValue={200}
				key="theseServicesAreFor"
				testId="theseServicesAreFor"
				options={[
					{
						label: "Personal",
						value: 100,
					},
					{
						label: "Business",
						value: 200,
					}
				]}
				displayAsRow={false}
			/>
		</Box>
	);
};
